import { Grid } from "@mui/material";
import React from "react";
import moment from "moment";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";

const AdminUserDetailsBottomCardSection = ({
  adminUserDetails,
}) => {
  return (
    <Grid container style={interactionsContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*Date added section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Date Added"}
          value={
            adminUserDetails?.createdAt &&
            moment
              .unix(adminUserDetails?.createdAt?.seconds)
              .format("MM-DD-YYYY")
          }
          disabled={true}
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Last Login section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Last Login"}
          value={
            adminUserDetails?.lastLoginDate &&
            moment
              .unix(adminUserDetails?.lastLoginDate?.seconds)
              .format("MM-DD-YYYY")
          }
          disabled={true}
        />
      </Grid>
    </Grid>
  );
};

export default AdminUserDetailsBottomCardSection;

const interactionsContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginTop: 20,
  marginBottom: 100,
};
